import { createFileRoute } from '@tanstack/react-router'
import { LegalPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/termini')({
  loader: () =>
    loadPageData({
      data: { kind: 'legal', locale: 'it', params: { legalKind: 'agb' } },
    }),
  head: () => staticRouteHead('terms', 'it'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <LegalPage kind="agb" />
    </CatalogProvider>
  )
}
